module.exports = __webpack_public_path__ + "hendel_machado--00484d5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/hendel_machado.jpg
// module id = 165
// module chunks = 0